import { formatFn } from './formatFn';
import { formatters } from '../formatters';

import { humanizers } from '../humanizers';
import { humanizeFn } from './humanizeFn';
import { parse } from './parse';

/**
 * Devuelve el objeto `tz` que contiene los metodos de formateo **aplicando el timezone** `edicom.locale.timezone`.
 * Nota que `tz()` es a su vez una función para aplicar el timezone a una fecha.
 *
 * @param {Object} state
 * @returns {Object}
 */
export function Tz(state) {
  const tz = parse.bind(null, state);
  tz.parse = parse.bind(null, state);
  tz.format = formatters.format.bind(null, state, formatFn);
  tz.datetime = formatters.datetime.bind(null, state, formatFn);
  tz.datetimelong = formatters.datetimelong.bind(null, state, formatFn);
  tz.date = formatters.date.bind(null, state, formatFn);
  tz.time = formatters.time.bind(null, state, formatFn);
  tz.timelong = formatters.timelong.bind(null, state, formatFn);
  tz.humanizeDatetime = humanizers.datetime.bind(null, state, humanizeFn);
  tz.humanizeDatetimelong = humanizers.datetimelong.bind(null, state, humanizeFn);
  tz.humanizeDate = humanizers.date.bind(null, state, humanizeFn);
  tz.humanizeTime = humanizers.time.bind(null, state, humanizeFn);
  tz.humanizeTimelong = humanizers.timelong.bind(null, state, humanizeFn);

  return tz;
}
